import { api } from 'utils/hooks/useApi';

export const createForMoveToFolder = (values: any): Promise<any | boolean> =>
  api().post(`/portal-api/studyRequest/createForMoveToFolder`, values);

export const editRequestForMoveToFolder = (values: any): Promise<any | boolean> =>
  api().post(`/portal-api/studyRequest/editForMoveToFolder`, values);
